import { Vue, Component, Watch, Prop } from "vue-property-decorator";
import DatePicker from "v-calendar/lib/components/date-picker.umd";
import ListDropdown from "@/components/list-dropdown";
import { fakeLex } from '@/fake';
import { Getter } from 'vuex-class';
import ComCommune from '@/lib/models/com-commune';
import { getCommunes } from '@/lib/services';
import Query from '@/lib/models/query';
import { lexLabel, loadingClass } from '@/lib/helpers';
import XInput from '@/components/x-input';
import { FLEX_PROFILES } from '@/lib/models/user';
import { LsitCavConfidentialite, LcavTypecav } from '@/lib/models/gen-lexs';
import Icon from '@/components/icon';

@Component
export default class SearchBar extends Vue {

  @Getter userDepts;
  @Getter getLexique;
  @Getter userhHasHigherFlexProfileThan;

  @Prop({required: true, type: Object}) readonly query!: Query;
  @Prop({default: false, type: Boolean}) readonly isSearching!: boolean;

  protected coms: ComCommune[] = [];

  get userDeptsSorted() {
    return [...this.userDepts].sort((a, b) => a.numDept.localeCompare(b.numDept));
  }

  @Watch("query.numDept")
  async onDeptChange(next) {
    if (next) {
      this.coms = await getCommunes(next);
    } else {
      this.coms = [];
      this.query.numInsee = null;
    }
  }

  protected advanced: boolean = false;

  onToggleAdvanced() {
    this.advanced = !this.advanced;
  }

  onClickResetDatePreco() {
    this.query.preconisationEcheanceStart = null;
    this.query.preconisationEcheanceEnd = null;
  }

  onClickSearch() {
    this.$emit("commit", this.query);
  }

  render() {
    return (
      <div class="search-bar">
        <div class="search-bar-rows">
          <div class="search-bar-row">
            <div class="control">
              <XInput vModel={this.query.numCavite} class="input is-small" placeholder="Identifiant"/>
            </div>
            {this.userhHasHigherFlexProfileThan(FLEX_PROFILES.CUS_LECTEUR) && (
            <div class="control">
              <XInput vModel={this.query.idCus} class="input is-small" placeholder="Identifiant EMS"/>
            </div>
            )}
            <div class="control">
              <ListDropdown class="basic"
                data={this.userDeptsSorted}
                vModel={this.query.numDept}
                labelFn={o => `${o.numDept} - ${o.nom}`}
                transform={v => v.numDept}
                prompt="Département"/>
            </div>
            <div class="control">
              <ListDropdown class="basic"
                data={this.coms}
                vModel={this.query.numInsee}
                labelFn={o => `${o.nom} (${o.numInsee})`}
                transform={v => v.numInsee}
                prompt="Commune"/>
            </div>
            <div class="control">
              <ListDropdown class="basic"
                data={this.getLexique("StatutValidation")}
                vModel={this.query.statutV}
                labelFn={lexLabel}
                transform={v => v.id}
                prompt="Validation"/>
            </div>
            <div class="control">
              <ListDropdown class="basic"
                data={this.getLexique("StatutValidation")}
                vModel={this.query.statutR}
                labelFn={lexLabel}
                transform={v => v.id}
                prompt="Diffusion"/>
            </div>
            {!this.advanced && (
              <div class="control">
              <button class="button is-small" onClick={this.onToggleAdvanced}>
                <Icon icon="flask" class="icon is-small grey"/>
                <span>Recherche avancée</span>
              </button>
            </div>
            )}
          </div>
          {this.advanced && (
            <div class="search-bar-row">
            <div class="control">
              <XInput vModel={this.query.nomCavite} class="input is-small" placeholder="Nom de la cavité"/>
            </div>
            <div class="control">
              <XInput vModel={this.query.coordX} ofType="number" class="input is-small" placeholder="Coordonnée X L93"/>
            </div>
            <div class="control">
              <XInput vModel={this.query.coordY} ofType="number" class="input is-small" placeholder="Coordonnée Y L93"/>
            </div>
            <div class="control">
              <XInput vModel={this.query.libelleSourceInfo} class="input is-small" placeholder="Source d'information"/>
            </div>
            <div class="control">
              <ListDropdown class="basic"
                data={this.getLexique(LsitCavConfidentialite)}
                vModel={this.query.confidentialite}
                labelFn={v => v.confidentialite}
                transform={v => v.confidentialite}
                prompt="Confidentialité"/>
            </div>
            <div class="control">
              <ListDropdown class="basic"
                  data={this.getLexique(LcavTypecav)}
                  vModel={this.query.typeCavite}
                  labelFn={v => v.famille}
                  transform={v => v.famille}
                  prompt="Type de cavité"/>
            </div>
            {this.userhHasHigherFlexProfileThan(FLEX_PROFILES.POC_LECTEUR) && (
            <div class="control date-range-control">
              <DatePicker vModel={this.query.preconisationEcheanceDateRange} mode="range"
                input-props={{ class: "date-range-input", readonly: true, placeholder: "Echéance de préconisation"}}/>
              <div class="icon has-text-danger is-clickable" onClick={() => this.onClickResetDatePreco()}>x</div>
            </div>
            )}
            <div class="control">
              <button class="button is-small" onClick={this.onToggleAdvanced}>masquer</button>
            </div>
          </div>
          )}
        </div>
        <div class="search-bar-submit-btn-zone">
          <button class={`button is-small is-info is-full-height ${loadingClass(this.isSearching)}`}
            disabled={!this.query.notEmpty}
            onClick={this.onClickSearch}>Lancer la recherche</button>
        </div>
      </div>
    )
  }
}
// VUE JSX HOT LOADER //
if (module.hot) require("/Users/home/j2ee/projects/cavites/src/main/client/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-b23435ac/search-bar.tsx" });